<template>
  <q-page>
    <Puil :id="id" />
  </q-page>
</template>

<script setup>
import Puil from "@/components/puil/Puil.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
const route = useRoute();
const id = computed(() => route.params?.id);
</script>
